// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseFormikWrapper_root__2J74f","error":"BaseFormikWrapper_error__gm_WW","infoDialogBody":"BaseFormikWrapper_infoDialogBody__3JqMB"};